import type { FC } from 'react';
import React from 'react';

import { cva } from 'class-variance-authority';

import { cn } from '@wwe-portal/ui/lib/lib';
import iconSrc from '@wwe-portal/ui/assets/images/subscription/club_coin_icon.webp';

const iconVariants = cva('', {
  variants: {
    size: {
      small: 'w-5 h-[18px]',
      default: 'w-[26px] h-[22px]',
      large: 'w-[28px] h-6',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

export type ClubCurrencyIconV2Props =
  React.ReactComponentElement<'img'>['props'] & {
    size?: 'small' | 'default' | 'large';
  };
export const ClubCurrencyIconV2: FC<ClubCurrencyIconV2Props> = ({
  className,
  size,
  ...props
}) => {
  return (
    <img
      alt="Club Coin"
      className={cn(iconVariants({ size }), className)}
      src={iconSrc}
      {...props}
    />
  );
};
